import React from 'react';

import { ProductTile } from "@project-stories/ecommerce/Product/ProductTile";
import Slider from '@src/stories/client/Slider/Slider';

export const MegamenuFeaturedCollection = ({ settings, collectionBlock }) => {
  const { collection: { products } } = collectionBlock;

  return (
    <div className="megamenu-featured-collection py-8 lg:pl-8 xl:pl-16 overflow-auto">
      <h6 className="mb-4">
        {collectionBlock?.settings?.title || 'Featured Collection'} - {products.length} products
      </h6>

      <div className="relative min-h-[500px]">
        <Slider>
          {products.map((product, index) => (
            <div
              key={`featured_collection_${index}_${product.id}`}
              className="h-full"
            >
              <ProductTile
                settings={settings}
                product={product}
              />
            </div>
          ))}

          {products.length > 2 && (
            <div className="lg:pl-8 xl:pl-16"></div>
          )}
        </Slider>
      </div>
    </div>
  );
};

export default MegamenuFeaturedCollection;
